import { createAsync, query } from "@solidjs/router";
import { For, Show } from "solid-js";
import { schemeData } from "~/lib";

import { getCertifiersQueryServer } from "~/_server/dynamoQueries";

const getCertifiers = query( async () => {
	"use server";

	return await getCertifiersQueryServer();
}, "getCertifiers" );

export default () => {
	const certifiers = createAsync( () => getCertifiers(), { deferStream: true } );

	return (
		<div class="rias-content col-span-full">
			<h1>Design Certifiers</h1>

			<For each={certifiers()?.sort( ( a, b ) => a.lastName.localeCompare( b.lastName ) )} >
				{
					certifier => {
						const uniqueApprovedBodies = Object.values(
							certifier.subs.reduce( ( acc, sub ) => {
								if ( sub.approvedBody ) {
									acc[sub.approvedBodyId] = sub.approvedBody;
								}

								return acc;
							}, {} )
						);

						if ( uniqueApprovedBodies.length === 0 ) {
							return null;
						}

						return (
							<div class="mb-12">
								<h3 class="text-4xl font-extralight">{certifier.name} {certifier.qualifications}</h3>
								<h5 class="text-lg"><em>Certification of {[...new Set( certifier.subs.map( s => schemeData( s.scheme ).name ) )].join( ', Certification of ' )}</em></h5>

								<For each={uniqueApprovedBodies}>
									{
										ab => (
											<>
												<p class="mt-4"><span class="font-bold">{ab?.address.title}</span>
													<br />{[ab?.address.addr1, ab?.address.addr2, ab?.address.town, ab?.address.county, ab?.address.postcode].filter( Boolean ).join( ', ' )}
													<Show when={ab?.phone}>
														<br />{ab?.phone}
													</Show>
												</p>
											</>
										)
									}
								</For>

								<a href={`mailto:${certifier.email}`}>{certifier.email}</a>
							</div>
						);
					}
				}
			</For>
		</div>
	);
}


/*

						<div class="certifier"><h3>{certifier.name}</h3>
							<h5><em>Certification of Design (Section 6 - Energy) for Domestic Buildings</em></h5>
							<strong>Richard Atkins, Chartered Architect</strong>
							<br />1, Carlaverock Farm Cottage, Tranent, East Lothian, EH33 2NF
							<br />01875 614105
							<br />
							<a href={`mailto:${certifier.email}`}>{certifier.email}</a>
						</div> 

						*/